import React, {PropTypes} from "react";
import Banner from "../common/Banner";
import session from "../../classes/session";
import DisplayTable from "../common/DisplayTable";
import {hashHistory} from "react-router";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import Button from "react-bootstrap/lib/Button";
import axios from "axios";
import Constants from "../../classes/constants"

let emp = session.employees;

class ProfilePage extends React.Component {

  constructor() {
    super();
    this.state = ({emp: session.employees, employee: {}, name: null, empId: null, teamEmployee: [{}], show: true, reporting: []})
  }

  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    let i = window.location.hash.split('?')[0].split('/')[3];
    axios.get(process.env.REQ_URL + "/aboutEmp?q=" + i, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.setState({employee: response.data.data})
      axios.get(process.env.REQ_URL + "/aboutEmpTeam?q=" + i, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        let name = this.state.employee.employeeCode + " - " + this.state.employee.name;
        this.setState({teamEmployee: response.data.data, name: name, empId : this.state.employee.employeeCode})
      }).catch((error) => {
        console.log(error);
      });
      axios.get(process.env.REQ_URL + "/getReporting?q=" + i, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        this.setState({reporting: response.data.data})
      }).catch((error) => {
        console.log(error);
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  componentWillReceiveProps(nextProps) {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    let i = nextProps.params.id;
    axios.get(process.env.REQ_URL + "/aboutEmp?q=" + i, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.setState({employee: response.data.data})
      axios.get(process.env.REQ_URL + "/aboutEmpTeam?q=" + i, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        let name = this.state.employee.employeeCode + " - " + this.state.employee.name;
        this.setState({teamEmployee: response.data.data, name: name, empId : this.state.employee.employeeCode})
      }).catch((error) => {
        console.log(error);
      });
      axios.get(process.env.REQ_URL + "/getReporting?q=" + i, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        this.setState({reporting: response.data.data})
      }).catch((error) => {
        console.log(error);
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  render() {
    console.log(this.state.employee);
    return (
      <div>
        <Banner name={this.state.name}/>
        <div className="container">
          <div className="wrapper-1" style={{paddingTop: 0}}>
            <div className="row clearfix">
              <div className="col-xs-12">
                <div className="tab-content responsive">

                  <div className="row clearfix" style={{paddingBottom: '50px'}}>

                    <DisplayTable empNo={this.state.empId} data={this.state.employee} height="250px" width="250px"/>
                    <div className="col-md-3">
                    </div>
                    <div className="col-md-8" style={{marginLeft: '20px'}}>
                      <b><u>Reporting Structure</u></b> <br/><br/>
                      {this.state.reporting.map((node, index)=> {
                        return <font>
                          {index != 0 ? <img style={{paddingLeft: '1em', paddingRight: '1em'}}
                                             src="/public/images/nextR.png"/> : null}
                          <a href={"#/1/profile/" + node.empId}
                          >{node.fullName}</a></font>
                      })}


                    </div>
                    <div className="col-md-11">
                    </div>


                    {this.state.teamEmployee.length != 0 ?
                      <div className="col-md-12">
                        <h2 >Team Details</h2>

                        <BootstrapTable height="550"
                                        search={true}
                                        containerStyle={{paddingTop: 0}}
                                        data={this.state.teamEmployee} striped={false} hover={true} condensed={true}>
                          <TableHead dataSort={true}


                                     width={160} dataField="name"
                                     dataFormat={(cell, row)=> {
                                     let profilePic = Constants.defaultProfilePicture[0];
                                      if(row.imageUrl){
                                        profilePic = row.imageUrl;
                                      }
                                       return <img src={profilePic} height="150px" width="160px"/>

                                     }
                                     }>Photo</TableHead>
                          <TableHead dataSort={true}
                                     isKey={true}
                                     hidden={true}
                                     width={70}
                                     dataField="empId">Id</TableHead>
                          <TableHead dataSort={true}
                                     width={110} dataField="fullName"
                                     dataFormat={(cell, row)=> {
                                       return <a href={"#/1/profile/" + row.empId}
                                       >{row.empId}<br/><br/>{cell}</a>
                                     }
                                     }>Name</TableHead>


                          <TableHead dataSort={true}

                                     dataFormat={this.checkNull}
                                     width={150}
                                     dataField="officeEmailId">Email Id</TableHead>

                          <TableHead dataField="contactNo"

                                     dataFormat={this.checkNull}
                                     dataSort={true}
                                     width={100}>Phone no</TableHead>
                          <TableHead dataField="department"
                                     dataFormat={this.checkNull}
                                     dataSort={true}
                                     width={100}>Department</TableHead>
                          <TableHead dataField="designation"
                                     dataFormat={this.checkNull}
                                     dataSort={true}
                                     width={120}>Designation</TableHead>
                          <TableHead dataField="officeLocation"
                                     dataFormat={this.checkNull}
                                     dataSort={true}
                                     width={120}>Location</TableHead>


                        </BootstrapTable>
                      </div>
                      : null
                    }

                  </div>
                  <Button onClick={()=> {
                    hashHistory.goBack();
                  }}>Back</Button>

                </div>


              </div>
            </div>
          </div>
        </div>


      </div>
    );
  }
}

ProfilePage.propTypes = {};

export default ProfilePage;





/** WEBPACK FOOTER **
 ** ./src/components/ProfilePage/ProfilePage.js
 **/